/* Block - Cards.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "./block-cards.scss";
import rs_card_link from "../../js/component/_card";

rs_card_link.init('.rs-card-container');
